// extracted by mini-css-extract-plugin
export var bar = "featuredVideo-module--bar--d9b1c";
export var featured_play_btn = "featuredVideo-module--featured_play_btn--d4095";
export var featured_section_img = "featuredVideo-module--featured_section_img--4edb3";
export var featured_video_container = "featuredVideo-module--featured_video_container--7a29f";
export var show = "featuredVideo-module--show--445a1";
export var video = "featuredVideo-module--video--a5183";
export var video_wrapper = "featuredVideo-module--video_wrapper--d5b53";